'use client';
import React, { useEffect, useState } from 'react';
import ds from '@/styles/ds/ds.module.scss';
// import { motion } from 'framer-motion';
import { OnboardingStepsEnum, useOnboardingStoreActions } from '../../../store';
import { useUpdateStep } from '@/backend/onboarding/post-update-step';
import { usePrivyFunctions, usePrivyUser, useUser } from '@/store';
import { useUpdatePrivyUser } from '@/backend/user/post-update-privy-user';
import { icons } from '@/Icons';

interface EmailVerificationProps {
	isOnboarding?: boolean;
}

const EmailVerification = ({ isOnboarding }: EmailVerificationProps) => {
	const { updateStep } = useUpdateStep();
	const privyUser = usePrivyUser();

	const user = useUser();
	const { updatePrivyUser } = useUpdatePrivyUser();
	const privyFunctions = usePrivyFunctions();

	useEffect(() => {
		if (user?.email) return;
		const linkedAccounts = privyUser?.linkedAccounts || [];
		const emailAccount = linkedAccounts.find((a) => a.type === 'email');

		const email = emailAccount?.address;
		if (email) {
			updatePrivyUser();
			updateStep(user?.currentOnboardingStep);
		}
	}, [privyUser]);

	return (
		<div className="flex flex-col gap-5 my-auto">
			<p className={`${ds.sectionHeader} flex items-center gap-3`}>
				<span className="w-6 h-6 relative text-dove-white-o-70 ">
					<icons.email />
				</span>
				Verify your Email
			</p>
			<p>
				{isOnboarding
					? 'Please verify your email address to continue. We will send you a verification code to your email address.'
					: 'You must verify your email before you can deposit.'}
			</p>
			<button
				onClick={(e) => {
					if (privyFunctions?.linkWallet) {
						try {
							privyFunctions?.linkEmail();
						} catch (error) {
							// console.error('Error linking email:', error);
						}
					}
				}}
				aria-label="Continue"
				className={`${ds.primary} ${ds.purpleWhite} h-10 !px-4`}
			>
				Verify Email
			</button>
			{isOnboarding ? (
				<button
					aria-label="Skip"
					type="button"
					className=" underline font-bold underline-offset-2 motion-safe:hover:text-electric-sky duration-200 transition-colors"
					onClick={(e) => {
						e.preventDefault();
						updateStep(user?.currentOnboardingStep);
					}}
				>
					Skip
				</button>
			) : null}
		</div>
	);
};

export default EmailVerification;
